import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './custom-dropdown-label.scss';

const NOT_AVAILABLE = 'N/A';

export function FancyLabel({
  highlightText = 'Most Popular',
  highlightTextClasses = 'text-primary-darker size-10 fw-bold',
  primaryText = '',
  primaryTextClasses = '',
  secondaryText = null,
  secondaryTextClasses = '',
  showHighlightText = false,
  textWrapperClasses = 'pe-1_5 w-100',
}) {
  return (
    <div className={classnames('custom-dropdown-label', textWrapperClasses)}>
      {showHighlightText && <div className={classnames('highlight-text', highlightTextClasses)}>{highlightText}</div>}
      <div className={classnames('fw-bold text-truncate', primaryTextClasses)} title={primaryText}>
        {primaryText}
      </div>
      {secondaryText && secondaryText !== NOT_AVAILABLE && (
        <div className={classnames('text-truncate', secondaryTextClasses)} title={secondaryText}>
          {secondaryText}
        </div>
      )}
    </div>
  );
}

FancyLabel.propTypes = {
  highlightText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  highlightTextClasses: PropTypes.string,
  primaryText: PropTypes.string,
  primaryTextClasses: PropTypes.string,
  secondaryText: PropTypes.string,
  secondaryTextClasses: PropTypes.string,
  showHighlightText: PropTypes.bool,
  textWrapperClasses: PropTypes.string,
};
